// src/Components/Common/AIChat/FeedbackPrompt.js
import React from 'react';
import { Button, Col, Row } from 'reactstrap';

const FeedbackPrompt = ({ lastMessage, onPerfectAnswer, onNotPerfectAnswer, t }) => {
    // Don't render if there's no message to give feedback on.
    if (!lastMessage) {
        return null;
    }

    // --- Renders the content based on the feedback state ---
    const renderFeedbackContent = () => {
        // State 1: Feedback has been given as "Perfect" (IsLiked === 1)
        // if (lastMessage.IsLiked === 1) {
        //     return (
        //         <div className="text-center text-success">
        //             <i className="ri-thumb-up-fill fs-3 mb-1"></i>
        //             <h6 className="mb-1">{t("PerfectMessage")}</h6>
        //             {lastMessage.SenderName && (
        //                 <p className="text-muted fs-12 mb-0">
        //                     {t("ResponseFrom")} {lastMessage.SenderName}
        //                 </p>
        //             )}
        //         </div>
        //     );
        // }

        // State 2: Feedback has been given as "Not Perfect" (IsLiked === 2)
        // if (lastMessage.IsLiked === 2 && lastMessage.FeedbackMessage) {
        //     return (
        //         <div className="text-center w-100">
        //             <p className="text-muted fs-12 ">{t("YourFeedbackHelps")}</p>
        //             <blockquote 
        //                 className="blockquote-custom bg-white border-start border-danger border-3 p-2 rounded mx-auto" 
        //                 style={{ maxWidth: '90%', textAlign: 'start' }}
        //             >
        //                 <p className="mb-1 fst-italic">"{lastMessage.FeedbackMessage}"</p>
        //                 {lastMessage.SenderName && (
        //                     <footer className="blockquote-footer mt-0 fs-12">
        //                         {t("ResponseFrom")}{' '}
        //                         <cite title="Sender Name">{lastMessage.SenderName}</cite>
        //                     </footer>
        //                 )}
        //             </blockquote>
        //         </div>
        //     );
        // }

        // Default State: Pending feedback
        return (
            <div className="text-center">
                <Row className="justify-content-center align-items-center">
                    <Col xs="auto" className="pe-2">
                        <p className="mb-0 text-muted">{t("HowWasThisResponse")}</p>
                    </Col>
                    <Col xs="auto">
                        <div className="d-flex gap-2">
                            <Button
                                size="sm"
                                color="light"
                                onClick={() => onPerfectAnswer(lastMessage)}
                            >
                                <i className="ri-thumb-up-line align-bottom"></i> {t("Perfect")}
                            </Button>
                            <Button
                                size="sm"
                                color="light"
                                onClick={() => onNotPerfectAnswer(lastMessage)}
                            >
                                <i className="ri-thumb-down-line align-bottom"></i> {t("NotPerfect")}
                            </Button>
                        </div>
                    </Col>
                </Row>
                <p className="fs-12 text-muted mt-2 mb-0">
                    {t("PleaseProvideFeedBack")}
                </p>
            </div>
        );
    };

    return (
        // Wrapper with reduced height and padding for a more compact look
        <div 
            className="bg-light-subtle p-2 rounded d-flex flex-column justify-content-center" 
            // style={{ minHeight: '100px' }}
        >
            {renderFeedbackContent()}
        </div>
    );
};

export default FeedbackPrompt;